import React, { useState } from 'react';
import img1 from '../../assets/img/Poorwill_3/poorwill1.JPG';
import img2 from '../../assets/img/Poorwill_3/poorwill2.JPG';
import img3 from '../../assets/img/Poorwill_3/poorwill3.JPG';
import img4 from '../../assets/img/Poorwill_3/poorwill4.JPG';
import img5 from '../../assets/img/Poorwill_3/poorwill5.JPG';
import img6 from '../../assets/img/Poorwill_3/poorwill6.JPG';
import img7 from '../../assets/img/Poorwill_3/poorwill7.JPG';
import img8 from '../../assets/img/Poorwill_3/poorwill8.JPG';
import img9 from '../../assets/img/Poorwill_3/poorwill9.JPG';
import img10 from '../../assets/img/Poorwill_3/poorwill10.JPG';
import img11 from '../../assets/img/Poorwill_3/poorwill11.JPG';
import img12 from '../../assets/img/Poorwill_3/poorwill12.JPG';
import img13 from '../../assets/img/Poorwill_3/poorwill13.JPG';
import img14 from '../../assets/img/Poorwill_3/poorwill14.JPG';
import img15 from '../../assets/img/Poorwill_3/poorwill15.JPG';
import img16 from '../../assets/img/Poorwill_3/poorwill16.JPG';

import arrow from '../../assets/arrow2.png';
import arrowdown from '../../assets/arrowdown.png';

export default function Poorwill(props) {

    const [opened, setOpened] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();

        if (!opened) {
            setOpened(true);
        } else {
            setOpened(false);
        }
    }

    return ( 
        <div className="used-project">
            <div className="box1">
                <img alt="" className="smed" src={img1}></img>
                <img alt="" className="unknown" src={img2}></img>
                <img alt="" className="smed" src={img3}></img>
            </div>
            <div className="box1">
                <img alt="" className="smed" src={img4}></img>
                <img alt="" className="smed" src={img5}></img>
                <img alt="" className="smed" src={img6}></img>
            </div>
            <div className="box1">
                <img alt="" className="smed" src={img7}></img>
                <img alt="" className="unknown" src={img8}></img>
                <img alt="" className="smed" src={img9}></img>
            </div>
            <div className="box1">
                <img alt="" className="unknown" src={img10}></img>
                <img alt="" className="unknown" src={img11}></img>
                <img alt="" className="unknown" src={img12}></img>
            </div>
            <div className="box1">
                <img alt="" className="smed" src={img13}></img>
                <img alt="" className="smed" src={img14}></img>
                <img alt="" className="smed" src={img15}></img>
            </div>
            <div className="box1">
                <img alt="" className="smed" id="bottom-pic" src={img16}></img>
            </div>
            <footer className="projfoot">
                <div className="proj-foot-div">
                    <div className={opened ? "opened":"closed active"}>
                        
                        <button className="details-btn" onClick={handleClick}><img alt="clickable arrow" src={opened ? arrowdown : arrow }></img></button>
                        <h4 id="foot-head" className="footer-header">Poorwill — Photography + Art Direction</h4>
                        <div className="footer-content">
                            <p>
                            <br />
                            Poorwill is a Minneapolis based band, featuring 4 amazing musicians. Their newest album “Tough Kid” is out now.                            
                            <br />
                            <br />
                            Shot on the Minneapolis Greenway path, these images feature the juxtaposition between color and shadows, greenery and plastic, and an almost renaissance painting feel.
                            <br />
                            <br />
                            </p> 
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
};